import { __extends } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { namespacedClassnames } from '../../common/namespace-classes';
import * as classnames from 'classnames';
import { KeyCode } from '../../common';
import { createResizeObserver } from '../../common/resize-observer';
import { ModalSize } from './modal-size';
import { ModalHeader } from './modal-header/modal-header';
import { ModalBody } from './modal-body/modal-body';
import { ModalFooter } from './modal-footer/modal-footer';
import { ModalSubHeader } from './modal-sub-header/modal-sub-header';
import { isString, isNumber } from 'util';
import * as ReactDOM from 'react-dom';
var Modal = /** @class */ (function (_super) {
    __extends(Modal, _super);
    function Modal(props) {
        var _a;
        var _b, _c;
        var _this = _super.call(this, props) || this;
        _this.modalContentElement = null;
        _this.modalBody = null;
        _this.minMargin = 25;
        _this.scrollLockClassName = 'aul-modal-scroll-lock';
        _this.resizeHackTimer = null;
        _this.modalSizeToClassMap = (_a = {},
            _a[ModalSize.X_SMALL] = 'modal-content-x-small',
            _a[ModalSize.SMALL] = 'modal-content-small',
            _a[ModalSize.MEDIUM] = 'modal-content-medium',
            _a[ModalSize.MEDIUM_LARGE] = 'modal-content-medium-large',
            _a[ModalSize.LARGE] = 'modal-content-large',
            _a);
        _this.state = {
            isContentOverflowing: false,
            hasHeader: false
        };
        _this.resizeObserver = createResizeObserver(function (w, h) { return _this.onResize(w, h); });
        _this.isReactElement = function (maybeComp) {
            return maybeComp && maybeComp.type && typeof maybeComp.type !== 'string';
        };
        _this.childNotModalComponent = function (child) {
            if (isString(child) || isNumber(child)) {
                return true;
            }
            var childType = child.type;
            if (isString(childType)) {
                return true;
            }
            return (childType.name) !== ModalHeader.name
                && (childType.name) !== ModalSubHeader.name
                && (childType.name) !== ModalBody.name
                && (childType.name) !== ModalFooter.name;
        };
        _this.isModalHeader = function (child) {
            if (isString(child) || isNumber(child) || isString(child.type)) {
                return false;
            }
            return child.type.name === ModalHeader.name;
        };
        _this.updateHasHeaderContext = function (props) {
            _this.setState({ hasHeader: _this.hasHeader(props) });
        };
        _this.setContentElement = function (elem) {
            if (elem) {
                _this.modalContentElement = elem;
                _this.modalBody = elem.querySelector('.modal-body');
                if (_this.modalBody) {
                    var modalHeader = elem.querySelector('.modal-header');
                    var modalSubHeader = elem.querySelector('.modal-sub-header');
                    var modalFooter = elem.querySelector('.modal-footer');
                    var headerHeight = modalHeader ? modalHeader.clientHeight : 0;
                    var subHeaderHeight = modalSubHeader ? modalSubHeader.clientHeight : 0;
                    var footerHeight = modalFooter ? modalFooter.clientHeight : 0;
                    var maxBodyHeight = "calc(\n\t\t\t\t\t100vh - " + headerHeight + "px - " + subHeaderHeight + "px - " + footerHeight + "px - " + _this.minMargin * 2 + "px\n\t\t\t\t)";
                    _this.modalBody.style.maxHeight = maxBodyHeight;
                }
                _this.resizeObserver.observeElem(elem);
            }
        };
        _this.onResize = function (_, height) {
            var modalBody = _this.modalBody;
            var currOverflow = _this.state.isContentOverflowing;
            var isOverflowing = modalBody ? height < (height - modalBody.clientHeight + modalBody.scrollHeight) : false;
            if (isOverflowing !== currOverflow) {
                _this.setState({ isContentOverflowing: isOverflowing });
            }
        };
        _this.handleEscKeyDown = function (e) {
            if (_this.props.onDismiss && e.keyCode === KeyCode.ESCAPE) {
                _this.props.onDismiss();
            }
        };
        _this.handleModalOpen = function () {
            if (!_this.props.disableScrollLock) {
                window.document.body.classList.add(_this.scrollLockClassName);
            }
            window.addEventListener('keydown', _this.handleEscKeyDown);
        };
        _this.handleModalClose = function () {
            if (_this.modalContentElement) {
                _this.resizeObserver.unobserveElem(_this.modalContentElement);
            }
            if (!_this.props.disableScrollLock) {
                window.document.body.classList.remove(_this.scrollLockClassName);
            }
            window.removeEventListener('keydown', _this.handleEscKeyDown);
        };
        _this.preventBubble = function (e) { return e.stopPropagation(); };
        _this.onDismiss = function () {
            if (_this.props.onDismiss) {
                _this.props.onDismiss();
            }
        };
        if (props.isOpen && !props.disableScrollLock) {
            (_c = (_b = window.document.body) === null || _b === void 0 ? void 0 : _b.classList) === null || _c === void 0 ? void 0 : _c.add(_this.scrollLockClassName);
        }
        _this.state.hasHeader = _this.hasHeader(props);
        _this.validateStructure(props);
        return _this;
    }
    Modal.prototype.componentWillReceiveProps = function (nextProps) {
        if (this.props.isOpen === nextProps.isOpen) {
            return;
        }
        this.updateHasHeaderContext(nextProps);
        this.validateStructure(nextProps);
        if (nextProps.isOpen) {
            this.handleModalOpen();
        }
        else {
            this.handleModalClose();
        }
    };
    Modal.prototype.componentWillUnmount = function () {
        this.resizeObserver.clean();
        this.handleModalClose();
    };
    Modal.prototype.validateStructure = function (props) {
        var childArray = React.Children.toArray(props.children);
        if (childArray.some(this.childNotModalComponent)) {
            // tslint:disable-next-line:max-line-length
            console.warn("Bad Modal structure: modal can only have ModalHeader, ModalSubHeader, ModalBody or ModalFooter as it's direct children.");
        }
    };
    Modal.prototype.hasHeader = function (props) {
        return React.Children.toArray(props.children).some(this.isModalHeader);
    };
    Modal.prototype.getChildContext = function () {
        var onDismiss = this.props.onDismiss;
        return {
            onDismiss: onDismiss,
            modalHasHeader: this.state.hasHeader,
            hideCloseButton: !!this.props.hideCloseButton
        };
    };
    Modal.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var sizeClass = this.modalSizeToClassMap[props.size];
        var overflowStateClass = this.state.isContentOverflowing ? 'content-overflow' : '';
        var classNames = namespacedClassnames('modal', props.className || '');
        var contentClassNames = classnames('modal-content', sizeClass, overflowStateClass);
        var renderModal = function () { return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: 'modal-overlay' },
                React.createElement("div", { className: contentClassNames, onClick: _this.preventBubble, ref: _this.setContentElement }, props.children)))); };
        var modal = props.usePortal
            ? ReactDOM.createPortal(renderModal(), document.body)
            : renderModal();
        return props.isOpen ? modal : null;
    };
    Modal.childContextTypes = {
        onDismiss: PropTypes.func,
        modalHasHeader: PropTypes.bool,
        hideCloseButton: PropTypes.bool
    };
    return Modal;
}(React.Component));
export { Modal };
//# sourceMappingURL=modal.js.map